import React, { useState } from "react";
import { FaBell, FaUser } from "react-icons/fa";
import { GoHomeFill } from "react-icons/go";
import { Outlet, NavLink } from "react-router-dom";
import SideBar from "./pages/SideBar";

import {
  Bell,
  Trophy,
  Activity,
  User,
  Clock,
  Zap,
  Star,
  Flame,
  Award,
  Heart,
} from "lucide-react";
import { useAuth } from "./context/AuthContext";
import InstallPWAButton from "./components/InstallPWAButton";

const Layout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
const {userData} = useAuth();
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };
  return (
    <div className="flex flex-col h-screen overflow-y-auto scroll-smooth focus:scroll-auto bg-gray-100 text-gray-900">
      {/* Header */}
      <div className="fixed w-full z-10">
        <header className="bg-[#120239] text-white py-4">
          <div className="mx-auto w-full max-w-7xl px-4 md:px-8 flex justify-between items-center">
            <div className="flex items-center gap-2">
              <svg
                className="h-8 w-8"
                viewBox="136.9861 99.9324 178.1554 174.2487"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g transform="matrix(1, 0, 0, 1, -53.93602752685547, -92.9327392578125)">
                  <g>
                    <g>
                      <path
                        d="M237.82,354.95c0.22,0.35,0.75,0.13,0.67-0.27l-26.16-130.05h0c-6.64,2.69-16.5,14.64-19.25,18.09 c-1.39,1.75-2.25,4.82-2.15,8.17c0.04,1.16,0.18,2.33,0.43,3.46C194.54,268.58,203.34,300.06,237.82,354.95z"
                        fill="#FF9200"
                      />
                      <path
                        d="M275.04,289.24c0,0,8.11-55.03,11.6-57.99c2.15-1.82,49.73-3.33,49.73-3.33l-0.43,53.41 c0.49,1.6-0.09,3.27-1.34,4.38c-64.19,57.14-86.77,71.88-92.82,80.36c-0.36,0.51,0.15,1.25,0.72,0.99 c51.81-23.43,104.83-58.7,123.56-73.04c2.33-1.78,2.04-4.68,2.07-7.61c0.48-39.83,2.85-78.31-2.41-85.93 c-0.55-0.8-1.38-1.38-2.32-1.62c-41.31-10.46-91.51-4.7-102.77-1.57c-1.64,0.46-2.89,1.76-3.29,3.41 c-14.21,57.75-6.89,124.78-5.82,136.03c0.05,0.53,0.68,0.77,1.08,0.42l64.65-56.02c1.7-1.52,1.82-4.15,0.27-5.82l-23.3-34.61 c-1.11-1.12-2.59,0.1-2.16,1.62c4.83,17.19,8.1,29.06,8.1,29.06L275.04,289.24z"
                        fill="#ffffff"
                      />
                    </g>
                  </g>
                </g>
              </svg>
              <h1 className="text-2xl font-bold">VIGOR</h1>
            </div>
            <div className="flex items-center space-x-4">
            {userData && (  <div className="hidden md:flex items-center">
                <div className="flex items-center bg-[#FF9200] bg-opacity-20 rounded-full px-3 py-1 mr-4">
              
                  <svg
                className="h-5 w-5 text-[#FF9200] mr-1"
                viewBox="276.8958 247.0658 40.18 99.84"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g transform="matrix(1, 0, 0, 1, 213.98580932617185, 213.98580932617188)">
                  <path
                    fill="#FF9200"
                    d="M63.49,132.8l-0.58,0.1l20.09-99.82c5.08,2.06,12.62,11.2,14.72,13.84c1.07,1.34,1.72,3.69,1.65,6.25&#10;&#9;&#9;l-0.33,2.65C96.6,66.71,89.86,90.8,63.49,132.8"
                  />
                  <path
                    fill="#ffffff"
                    d="M102.51,132.82l0.58,0.1L82.99,33.08c-5.09,2.06-12.63,11.21-14.74,13.85c-1.07,1.34-1.72,3.69-1.65,6.25&#10;&#9;&#9;l0.33,2.65C69.37,66.72,76.11,90.81,102.51,132.82"
                  />
                </g>
              </svg> <span className="text-white">{userData.vigor_points} Points</span>
                </div>
                <div className="flex items-center bg-[#FF9200] bg-opacity-20 rounded-full px-3 py-1">
                
                  <svg
                        viewBox="69.8655 71.9463 339.481 339.4806"
                        className="flex-shrink-0 w-5 h-5 mr-1 animate-flip"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g transform="matrix(0.6630480289459229, 0, 0, 0.6630480289459229, 69.86547088623047, 71.94631958007815)">
                          <path
                            fill="#EFB832"
                            d="M256,512C114.841,512,0,397.159,0,256S114.841,0,256,0s256,114.841,256,256S397.159,512,256,512z"
                          />
                          <g transform="matrix(1.190054, 0, 0, 1.190054, -45.374573, 225.235107)">
                            <path
                              d="M 211.034 99.593 C 211.254 99.943 211.784 99.723 211.704 99.323 L 185.544 -30.727 C 178.904 -28.037 169.044 -16.087 166.294 -12.637 C 164.904 -10.887 164.044 -7.817 164.144 -4.467 C 164.184 -3.307 164.324 -2.137 164.574 -1.007 C 167.754 13.223 176.554 44.703 211.034 99.593 Z"
                              fill="rgb(255, 146, 0);"
                            />
                            <path
                              d="M 248.254 33.883 C 248.254 33.883 256.364 -21.147 259.854 -24.107 C 262.004 -25.927 309.584 -27.437 309.584 -27.437 L 309.154 25.973 C 309.644 27.573 309.064 29.243 307.814 30.353 C 243.624 87.493 221.044 102.233 214.994 110.713 C 214.634 111.223 215.144 111.963 215.714 111.703 C 267.524 88.273 320.544 53.003 339.274 38.663 C 341.604 36.883 341.314 33.983 341.344 31.053 C 341.824 -8.777 344.194 -47.257 338.934 -54.877 C 338.384 -55.677 337.554 -56.257 336.614 -56.497 C 295.304 -66.957 245.104 -61.197 233.844 -58.067 C 232.204 -57.607 230.954 -56.307 230.554 -54.657 C 216.344 3.093 223.664 70.123 224.734 81.373 C 224.784 81.903 225.414 82.143 225.814 81.793 L 290.464 25.773 C 292.164 24.253 292.284 21.623 290.734 19.953 L 267.434 -14.657 C 266.324 -15.777 264.844 -14.557 265.274 -13.037 C 270.104 4.153 273.374 16.023 273.374 16.023 L 248.254 33.883 Z"
                              fill="rgb(18, 2, 57);"
                            />
                          </g>
                          <g className="opacity-50">
                            <path
                              fill="#AE8132"
                              d="M256.001,472.633c-119.452,0-216.633-97.181-216.633-216.633s97.18-216.633,216.633-216.633 c119.452,0,216.633,97.18,216.633,216.633S375.453,472.633,256.001,472.633z M256.001,94.604 c-88.994,0-161.396,72.402-161.396,161.396s72.402,161.396,161.396,161.396c88.994,0,161.396-72.402,161.396-161.396 S344.994,94.604,256.001,94.604z"
                            />
                          </g>
                          <g>
                            <circle
                              fill="#EFB832"
                              cx="65.963"
                              cy="256"
                              r="9.56"
                            />
                            <circle
                              fill="#EFB832"
                              cx="444.121"
                              cy="256"
                              r="9.56"
                            />
                          </g>
                        </g>
                        <path
                          fill="#040000"
                          className="opacity-5"
                          d="M256.12,511.759c65.556,0,131.113-24.952,181.02-74.859 c99.814-99.814,99.814-262.225,0-362.038C387.232,24.953,321.676,0,256.12,0L256.12,511.759z"
                          transform="matrix(0.6630480289459229, 0, 0, 0.6630480289459229, 69.86547088623047, 71.94631958007815)"
                        />
                      </svg>
                  <span className="text-white">{userData?.vigor_coins} Tokens</span>
                </div>
              </div>)}
              <InstallPWAButton />
              <Bell className="h-6 w-6 text-[#FF9200]" />
            </div>
          </div>
        </header>
      </div>
      {/* Content */}
      <main className="mx-auto w-full max-w-7xl px-4 md:px-8 py-6 my-10">
        <Outlet />
      </main>
      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 w-full bg-white  shadow-[rgba(0,0,0,0.1)_5px_0px_20px_2px]">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-8 py-1 flex justify-around items-center">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `flex flex-col items-center p-2 text-2xl ${
                isActive ? "text-orange-400" : "text-gray-800"
              }`
            }
          >
            {({ isActive }) => (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="284.1533 236.3524 57.3747 57.3747"
                className="w-8 h-8"
              >
                <path
                  d="M81.438 34.575c0-1.85.72-3.59 2.03-4.89a6.878 6.878 0 0 1 4.89-2.03h33.65v33.65c0 1.85-.72 3.59-2.03 4.89a6.878 6.878 0 0 1-4.89 2.03c-3.82 0-6.92-3.11-6.92-6.92v-19.05c0-.2-.08-.39-.22-.54a.773.773 0 0 0-.54-.22h-19.05c-3.81 0-6.92-3.1-6.92-6.92Z"
                  className="st0"
                  style={{
                    fill: `${isActive ? "#FF9200" : "#120239"}`,
                    transformOrigin: "101.723px 47.94px",
                  }}
                  transform="rotate(-45 367.621 -146.292)"
                />
              </svg>
            )}
          </NavLink>
          <NavLink
            to="/myVigor"
            className={({ isActive }) =>
              `flex flex-col items-center p-2 rounded-full -mt-5 bg-white shadow-[rgba(0,0,0,0.1)_5px_0px_20px_2px] ${
                isActive ? "text-orange-400" : "text-gray-800"
              }`
            }
          >
            {({ isActive }) => (
              <svg
                className="w-8 h-8"
                viewBox="276.8958 247.0658 40.18 99.84"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g transform="matrix(1, 0, 0, 1, 213.98580932617185, 213.98580932617188)">
                  <path
                    fill="#FF9200"
                    d="M63.49,132.8l-0.58,0.1l20.09-99.82c5.08,2.06,12.62,11.2,14.72,13.84c1.07,1.34,1.72,3.69,1.65,6.25&#10;&#9;&#9;l-0.33,2.65C96.6,66.71,89.86,90.8,63.49,132.8"
                  />
                  <path
                    fill="#120239"
                    d="M102.51,132.82l0.58,0.1L82.99,33.08c-5.09,2.06-12.63,11.21-14.74,13.85c-1.07,1.34-1.72,3.69-1.65,6.25&#10;&#9;&#9;l0.33,2.65C69.37,66.72,76.11,90.81,102.51,132.82"
                  />
                </g>
              </svg>
            )}
          </NavLink>
          <button
            onClick={toggleSidebar}
            className="flex flex-col items-center p-2 text-2xl text-gray-600"
          >
            <FaUser />
          </button>
        </div>
      </nav>

      <SideBar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
    </div>
  );
};

export default Layout;
